import {  Flex, Title, UnstyledButton } from '@mantine/core'
import React, { useEffect } from 'react'
import styles from "../styles.module.scss"
import { companyDeclinesInvetation, companyAcceptInvetation , getCompanyInvitationsToJoinOrganizations, useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { CheckInCircleFill, Trash2, XCircleFill } from '@geist-ui/icons';
import { Button } from '@common/components';

type InvitationType = {
    company_id: string,
    invitation_date : string,
    company_name: string,
    organization_id: string,
    organization_name: string,
    company_owner_email: string,
    state: string,
    type: string
}
function page() {
    const dispatch = useAppDispatch();
    const {  data   } = useAppSelector((state) => state.user, shallowEqual);
    const {  invitationOrganization, deleteOrgClient  } = useAppSelector((state) => state.organization, shallowEqual);
  
    // /reporttool/organisationlevel/company/decline-organization-invitation 
    function declineInvite(invitaion : InvitationType) {

        dispatch(companyDeclinesInvetation({
            company_id : invitaion?.company_id, 
        }))
    }

    function acceptInvite(invitaion : InvitationType) {
        dispatch(companyAcceptInvetation({
            company_id : invitaion?.company_id, 
        }))
    }

    const cancelInvite = (invite: any)=>{
        // console.log(invite);  
    }

    useEffect( () => { 

        // if ( !invitationOrganization ) {
            dispatch(getCompanyInvitationsToJoinOrganizations({}))
        // }

    } , [])


    

    const isErrorObject = (obj:string) => {
        return typeof obj === 'object' && obj !== null && 'message' in obj;
    };
    return (
        <div>
            <Title id='myorganizationTitle' className={styles['second-heading']} color={'#264547'} mb={'18px'} order={1}>
                Invitations
            </Title>
            <table className={styles.table} >
                    <thead>
                        <tr>
                            <th>Company name</th>
                            <th>Status </th>
                            <th>Permissions</th>
                            <th>Action </th>
                        </tr>
                    </thead>
                    <tbody>
                           {
                            Array.isArray(invitationOrganization) ? (
                            invitationOrganization.map((invitation : any) => (
                                <tr>
                                <td>{invitation?.company_name ?? '-'}</td>
                                <td>

                                    {
                                        invitation?.is_accepted === 'pending' ? (
                                            <Flex align={"center"} gap={"sm"}>
                                                <CheckInCircleFill color='yellow' />
                                                Pending
                                            </Flex>
                                        ) : invitation?.is_accepted === 'accepted' ? (
                                            <Flex align={"center"} gap={"sm"}>
                                                <CheckInCircleFill color='green' />
                                                Accepted
                                            </Flex>
                                        ) : invitation?.is_accepted === 'declined' ? (

                                            <Flex align={"center"} gap={"sm"}>
                                                <XCircleFill color='red' />
                                                Declined
                                            </Flex>
                                        ) : 
                                        invitation?.is_accepted === 'left' ? (

                                            <Flex align={"center"} gap={"sm"}>
                                                <XCircleFill color='red' />
                                                Left
                                            </Flex>
                                        ) : null
                                    }

                                </td>
                                <td>{invitation?.permissions}</td>
                                <td className={`${styles.flex}`}>
                                        {
                                                invitation?.is_accepted === 'pending' ? (
                                                    invitation?.type === "request" ? (
                                                        <UnstyledButton className={styles['delete-btn']} onClick={() => cancelInvite(invitation)} >
                                                            Cancel
                                                            <Trash2 color="#A80000" />
                                                        </UnstyledButton>
                                                    ) : (
                                                        <>
                                                            <Button onClick={() => acceptInvite(invitation)} >accept</Button>
                                                            <UnstyledButton className={styles['delete-btn']} onClick={() => declineInvite(invitation)} >
                                                                    decline
                                                                <Trash2 color="#A80000" />
                                                            </UnstyledButton>
                                                        </>
                                                    )
                                                ) : invitation?.is_accepted === 'accepted' ? (
                                                    <p>Joined</p>
                                                ) : invitation?.is_accepted === 'declined' ? (
                                                    <p>Declined</p>
                                                ) : invitation?.is_accepted === 'left' ? (
                                                    <p>Left</p>
                                                ) : null
                                            
                                        }
                                </td>
                            </tr>
                            ))
                           ) : isErrorObject(invitationOrganization) && (
                            <tr>
                                <td style={{textAlign: 'center'}} colSpan={4}>Company has no pending organization invites!</td>
                            </tr>
                        )
                        }
                     
                    </tbody>
                </table>


        </div>
    )
}

export default page